export default [
  {
    path: '/dashboards',
    name: 'dashboards',
    component: () => import('@/views/Dashboards/Dashboards.vue'),
    meta: {
      pageTitle: 'List All Dashboards',
      breadcrumb: [
        {
          text: 'Dashboards',
          active: true,
        },
      ],
    },
  },
  {
    path: '/dashboard/:id',
    component: () => import('@/views/Dashboards/Dashboard/Dashboard.vue'),
    name: 'Dashboard',
    meta: {
      pageTitle: 'Dashboard',
      breadcrumb: [
        {
          text: 'Dashboard',
          active: true,
        },
      ],
    },
  },
]
